import * as React from 'react';

import { cn } from '@/lib/cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export type DSButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
};

export const Button = React.forwardRef<HTMLButtonElement, DSButtonProps>(
  ({ variant = 'primary', className, children, ...props }, ref) => {
    const base =
      'inline-flex min-h-11 items-center justify-center gap-2 rounded-[14px] px-4 py-2 font-medium text-white transition-all duration-base ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#22D3EE] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0B1020] disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98] [&_svg]:stroke-[1.75]';

    const styles: Record<ButtonVariant, string> = {
      primary:
        'border border-transparent bg-[linear-gradient(90deg,#22D3EE_0%,#8B5CF6_50%,#D946EF_100%)] shadow-none hover:brightness-110 hover:shadow-[0_0_20px_rgba(139,92,246,0.35)]',
      secondary:
        'border border-[rgba(255,255,255,0.05)] bg-transparent text-white hover:bg-white/[0.04]',
      ghost: 'border border-transparent bg-transparent text-white hover:bg-white/[0.04]',
    };

    return (
      <button ref={ref} className={cn(base, styles[variant], className)} {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = 'DSButton';
